import { EventFormDto, EventResponseDto } from '@/Dtos/event-dto';
import { EndPoints } from '@/Core/Client';
import instanceAxios from '@/Core/Client/AxiosConfig';

export default function useEventCalendar() {
    async function createEvent(event: EventFormDto) {
        const formData = new FormData();
        Object.entries(event).forEach(([key, value]) => {
            if (key === "image") {
                formData.append(key, value as File, (value as File).name);
            } else if (key === "startDate" || key === "endDate") {
                formData.append(key, (value as Date).toISOString());
            } else {
                formData.append(key, value.toString());
            }
        });

        formData.append("host", "Admin");

        return await instanceAxios.post(EndPoints.venues.events(event.venueId), formData);
    }

    async function updateEvent(updatedEvent: EventResponseDto) {
        const result = await instanceAxios.put(EndPoints.events.details(updatedEvent.id!), updatedEvent);
        console.log(result);
    }

    function deleteEvent(eventId: string) {
        // Use filter to create a new array without the event to be deleted

        // Update the state with the new array of events
    }

    return { createEvent, updateEvent, deleteEvent };
}